import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { autoHyphen } from '@utils/common';
import { HeaderType } from '@utils/types';
import { getLoginType } from '@lib/enum';
import { User } from '@graphql/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';

type MemberStatusTableRowType = {
    header: HeaderType[];
    data: User;
};

const MemberStatusTableRow = ({
    header = [],
    data
}: MemberStatusTableRowType) => {
    const navigate = useNavigate();
    return (
        <TableRow
            onClick={() => navigate(`/member/status/detail/${data?.userId}`)}
        >
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createdAt
                    ? dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.uniqueKeyId || '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {typeof data?.snsType === 'number'
                    ? getLoginType(data?.snsType)
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {data?.name || '-'}
            </TableCell>
            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {data?.cellphone ? autoHyphen(data?.cellphone) : '-'}
            </TableCell>
            <TableCell $minWidth={header[5].minWidth} $width={header[5].width}>
                {data?.email || '-'}
            </TableCell>
            <TableCell $minWidth={header[6].minWidth} $width={header[6].width}>
                {typeof data?.qrCount === 'number' ? data?.qrCount : '-'}
            </TableCell>
        </TableRow>
    );
};

export default memo(MemberStatusTableRow);
